import { Either, Failure, Left, Right, ThreeDsTypes } from 'types';

export class ThreeDsController {
  iframeId = '3DsIframe';
  redirect_uri = encodeURI(window.location.origin);
  poolingInterval = null;
  needCancel = false;

  constructor() {}

  cancel() {
    this.needCancel = true;
  }

  destroy() {
    clearInterval(this.poolingInterval);
    this.poolingInterval = null;
    this.needCancel = false;
  }

  subscribe(): Promise<Either<Failure.Absract, ThreeDsTypes.DectaStates>> {
    this.needCancel = false;

    return new Promise((resolve, reject) => {
      try {
        const messageHandler = (event: MessageEvent) => {
          const data = event.data;

          if (data.type === '3dsResult' && data.payload) {
            window.removeEventListener('message', messageHandler);

            const success =
              data.payload.success || data.payload.success === 'true'
                ? true
                : false || false;

            resolve(
              Right(
                success
                  ? ThreeDsTypes.DectaStates.Success
                  : ThreeDsTypes.DectaStates.Failure,
              ),
            );

            this.destroy();
          }
        };

        window.addEventListener('message', messageHandler);

        const context = this;

        this.poolingInterval = setInterval(() => {
          if (context.needCancel) {
            window.removeEventListener('message', messageHandler);

            resolve(Left(new Failure.Terminated()));
            this.destroy();
          }
        }, 100);
      } catch (e) {
        this.destroy();
        console.error('DectaController error', e);

        reject(new Failure.RuntimeFailure());
      }
    });
  }
}
